import { motion } from "framer-motion";
import React from "react";
import { Link } from "react-router-dom";
import TechIcon from "../../../Utils/Icons/Icons";
import "./Hero.css";
import Button from "../../../Components/Button/Button";

const Hero = () => {
  return (
    <section className="heroSection"> 
      <div className="heroContent">
        <motion.h1
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          Innovate Fast. Launch Smart<span>,</span>
          <br />
          <span>Built by Softations.</span>
        </motion.h1>
        <motion.p
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        >
          From idea to launch, we help startups build scalable, reliable
          <br />
          software—faster than ever.
        </motion.p>
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
        > 
          <Link to="/contact">
          <Button className="heroBtn">
            Let's build your vision today
            <TechIcon name="move-right" className="heroArrow" />
          </Button></Link>
          
        </motion.div>
      </div>

      <motion.div
        className="heroCurveContainer"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }} 
      >
        <div className="heroCurve"></div>
      </motion.div>
    </section>
  );
};

export default Hero;